/** Reads one cookie by name (replaces js-cookie's `Cookies.get`). */
export const readCookie = (
  name: string,
  cookieString: string = document.cookie,
): string | null => {
  const prefix = `${encodeURIComponent(name)}=`;
  for (const part of cookieString.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      try {
        return decodeURIComponent(trimmed.slice(prefix.length));
      } catch {
        return trimmed.slice(prefix.length);
      }
    }
  }
  return null;
};
